import React, { createContext, useState, useContext } from "react";
import translations from './translations'

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en"); // Default to English
console.log("language-->",language)
  const t = (key) => {
    return (translations[language] && translations[language][key]) || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);